<template>
  <div ref="root" :style="{'--width':width,'--height':height}">
    <el-cascader
    :style="{'width': width}"
    v-model="provinces"
    :data-width="width"
    :options="options"
    @change="provincesChangeBtn" 
    :props="{ checkStrictly: true }"
    clearable></el-cascader>
  </div>
</template>

<script>
import { address } from './index'
export default {
  props:{
    width:{
      type:String,
      default:()=>'200px'
    },
    height:{
      type:String,
      default: () =>'32px'
    }
  },
  data() {
    return {
      options: [],
      provinces:''
    };
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      this.setProvinces(address[0],this.options);
    },
    setProvinces(item,provincesList){
      if(!!!item)return;
      if(!!!item.districts)return;

      item.districts.forEach((items,index)=>{

        let itemsCopy = {...items};
        delete itemsCopy.districts;

        provincesList.push({
          value:itemsCopy,
          label:items.name,
          code:items.adcode
        })

        if(items.districts.length){
          provincesList[provincesList.length - 1].children = []
          this.setProvinces(items,provincesList[provincesList.length - 1].children)
        }        
      })

      return;
    },
    provincesChangeBtn(ev){
      this.$emit('getVal',ev);
    },
    clear(){
      this.provinces = null;
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-cascader .el-input .el-input__inner{
  height: var(--height);
  width: var(--width);
}
</style>